import React from "react";
import { Media } from "reactstrap";

//Import Icons
import FeatherIcon from "feather-icons-react";

const FeatureBox = ({ data }) => {
  return data.map((feature, i) => (
    <div key={i} className="col col-md-12 col-sm-12">
      <Media className="features pt-2 pb-2">
        <Media body>
          <h5 className="title">
            <i>
              <FeatherIcon
                icon={feature.icon}
                className="icon-ex-md text-primary mr-1 mt-0"
              />
            </i>
            {feature.title}
          </h5>
          <p className="text-muted para mb-0">{feature.desc}</p>
        </Media>
      </Media>
    </div>
  ));
};

export default FeatureBox;
